const localization = {
  resizeNavigation: 'Resize navigation',
  navigationCollapsed: 'Navigation collapsed',
}

export default localization
